import { get } from 'common/api';

export const getCustomFieldGroups = params =>
  get('/v5/custom_field_groups', params);
